import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  ProductPopin: {
    minWidth: "959px !important",
    width: "959px !important",
    "& > div": {
      position: "relative",
    },
    "& .MuiTableRow-root.MuiTableRow-hover:hover": {
      backgroundColor: "transparent",
    },
    "& tr.MuiTableRow-hover": {
      cursor: "default !important",
    },
  },
  DesignationProduct: {
    maxWidth: "752px !important",
  },
  Badge: {
    position: "absolute",
    right: 0,
    top: "0px",
  },
  BadgetStock: {
    borderRadius: "11px !important",
    padding: "2px 4px 2px 5px !important",
    background: `${theme.color.blueLight} !important`,
  },
  Product__EntrepotTable: {
    padding: "0 !important",
    border: "none !important",
    boxShadow: "none !important",
  },
  ProductDescription: {
    marginBottom: "16px",
  },
  ProductRef: {
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  ProductQtyInput: {
    /* maxWidth: '280px', */
    marginBottom: "40px",
    opacity: 1,
  },
  ProductInputNumber: {
    flexDirection: "row !important",
    "& > div": {
      maxWidth: "119px",
      marginRight: "16px",
    },
    "& button": {
      margin: "0 !important",
    },
  },
  ProductAvailabilty: {
    marginTop: "40px",
    paddingTop: "24px",
    marginBottom: "42px",
    borderTop: "2px solid #DFE1E6",
    "& MuiPaper-root": {
      padding: 0,
      boxShadow: "unset",
    },
  },
  ProductSubstitutions: {
    borderTop: "2px solid #DFE1E6",
    paddingTop: "24px",
    paddingBottom: "30px",
    cursor: "pointer",
  },
  SubstitutionList: {
    display: "flex",
    flexWrap: "wrap",
  },
  SubstitutionItem: {
    width: "417px",
    height: "126px",
    border: "1px solid #DFE1E6",
    marginRight: "15px",
    marginBottom: "15px",
    padding: "15px",
    "& > div": {
      marginBottom: "15px",
    },
  },
  Unit: {
    fontWeight: "bold",
    "&:last-child": {
      padding: "7.5px",
    },
  },
  SubstituteRef: {
    display: "flex",
    "& span:last-child": {
      paddingLeft: "unset !important",
    },
    "& > div": {
      marginRight: "36px",
      "& + div": {
        borderLeft: "1px solid #DFE1E6",
        paddingLeft: "27px",
      },
    },
  },
  SubstituteCta: {
    marginBottom: "32px",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    maxWidth: "605px",
  },
  PopperProduct: {
    "& > div:last-child": {
      left: "307px !important",
      top: "28px !important",
    },
    maxWidth: "240px !important",
    margin: "unset !important",
    marginRight: "16px !important",
  },
  BtnOnPopper: {
    "&.MuiButtonGroup-grouped": {
      padding: 6,
      justifyContent: "flex-start",
      minWidth: "300px",
      background: theme.color.white,
    },
  },
}));
